import React from 'react';
import { FormattedMessage } from 'react-intl';
import Loader from '../../Utils/Loader';
import classes from './styles.module.css';
import Empty from './Empty';
import MobileCard from './MobileCard';

// Status pill
function StatusPill({ value }) {
    const text =
        value === 1 ? (
            <FormattedMessage id="TerminalsList.status.active" defaultMessage="Активен" />
        ) : (
            <FormattedMessage id="TerminalsList.status.inactive" defaultMessage="Неактивен" />
        );
    const bg = value === 1 ? '#e8f8ef' : '#f6e8e8';
    const color = value === 1 ? '#1b8356' : '#a43232';

    return <span style={{ padding: '2px 8px', borderRadius: 12, background: bg, color, fontSize: 12 }}>{text}</span>;
}

function TableRow({ row, isActive, onClick }) {
    const methods = [];
    if (row && row.isSBP)
        methods.push(<FormattedMessage key="sbp" id="TerminalsList.method.sbp" defaultMessage="СБП" />);
    if (row && row.isMP2P)
        methods.push(<FormattedMessage key="p2p" id="TerminalsList.method.p2p" defaultMessage="Р2Р" />);
    if (row && row.preAuth)
        methods.push(<FormattedMessage key="preAuth" id="TerminalsList.method.preAuth" defaultMessage="Предавт." />);
    if (row && row.partialRefund)
        methods.push(
            <FormattedMessage
                key="partialRefund"
                id="TerminalsList.method.partialRefund"
                defaultMessage="Част. возврат"
            />
        );
    if (row && row.partialReversal)
        methods.push(
            <FormattedMessage
                key="partialReversal"
                id="TerminalsList.method.partialReversal"
                defaultMessage="Част. отмена"
            />
        );
    if (row && row.recurring)
        methods.push(
            <FormattedMessage key="recurring" id="TerminalsList.method.recurring" defaultMessage="Рекуррент" />
        );

    const trClass = isActive ? classes.Active : '';

    return (
        <tr className={trClass} onClick={() => onClick(row)} style={{ cursor: 'pointer' }}>
            <td className={classes.HeaderCenter}>#{row && row.id}</td>
            <td className={classes.HeaderCell}>
                <div style={{ fontWeight: 600 }}>{(row && row.name) || '-'}</div>
            </td>
            <td className={classes.HeaderCell}>
                <div style={{ fontWeight: 600 }}>{(row && row.projectName) || '—'}</div>
            </td>
            <td className={classes.HeaderCell}>
                <div>{(row && row.providerName) || '—'}</div>
            </td>
            <td className={classes.HeaderCenter}>{typeof (row && row.balance) === 'number' ? row.balance : 0}</td>
            <td className={classes.HeaderCell}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {methods.length === 0 ? (
                        <span style={{ opacity: 0.6 }}>—</span>
                    ) : (
                        methods.map((m, i) => (
                            <span
                                key={i}
                                style={{ fontSize: 12, background: '#f3f4f6', padding: '2px 6px', borderRadius: 8 }}
                            >
                                {m}
                            </span>
                        ))
                    )}
                </div>
            </td>
            <td className={classes.HeaderCenter}>
                <StatusPill value={row && row.status} />
            </td>
        </tr>
    );
}

function TerminalsList({ data, currentId, isLoading, onSelect }) {
    const rows = Array.isArray(data) ? data : [];

    if (isLoading) return <Loader />;
    if (!rows.length) return <Empty />;

    return (
        <React.Fragment>
            <div className={classes.Scroll}>
                <table className={classes.Table}>
                    <thead>
                        <tr>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id="TerminalsList.table.id" defaultMessage="Идентификатор" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="TerminalsList.table.terminal" defaultMessage="Терминал" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="TerminalsList.table.project" defaultMessage="Проект" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="TerminalsList.table.provider" defaultMessage="Провайдер" />
                            </th>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id="TerminalsList.table.balance" defaultMessage="Баланс" />
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id="TerminalsList.table.methods" defaultMessage="Методы" />
                            </th>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id="TerminalsList.table.status" defaultMessage="Статус" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <TableRow
                                key={row && row.id ? row.id : Math.random()}
                                row={row}
                                isActive={currentId === (row && row.id)}
                                onClick={onSelect}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            {rows.map((row) => (
                <MobileCard
                    key={row && row.id ? row.id : Math.random()}
                    row={row}
                    currentId={currentId}
                    onClick={onSelect}
                />
            ))}
        </React.Fragment>
    );
}

TerminalsList.defaultProps = {
    data: [],
    isLoading: false,
    onSelect: () => {},
};

export default TerminalsList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalsList/index.js